import React from 'react';
import { CalendarDays } from 'lucide-react';

// Each person dates their own year: pick a start date and show/hide dates + sky notes
export default function DateSettings({ progress, onSave, doneCount }) {
  const { start_date: start, show_dates: show } = progress;
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-3 bg-white/70 border border-[#e4d8c3] rounded-2xl px-5 py-4" data-testid="f2-date-settings">
      <label className="inline-flex items-center gap-3 cursor-pointer select-none">
        <span className={`relative w-11 h-6 rounded-full transition-colors ${show ? 'bg-[#2b3550]' : 'bg-stone-300'}`}>
          <input type="checkbox" className="sr-only" checked={show} onChange={(e) => onSave({ start_date: start, show_dates: e.target.checked })} data-testid="f2-show-dates-toggle" />
          <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white shadow transition-transform ${show ? 'translate-x-5' : ''}`} />
        </span>
        <span className="font-body text-sm text-[#2b3550]">Show dates &amp; sky notes</span>
      </label>
      <label className="inline-flex items-center gap-2 font-body text-sm text-stone-600">
        <CalendarDays size={16} className="text-[#b07d3c]" />
        My Week 1 began
        <input
          type="date"
          value={start || ''}
          onChange={(e) => onSave({ start_date: e.target.value || null, show_dates: show })}
          className="border border-[#e4d8c3] rounded-lg px-2 py-1 text-[#2b3550] bg-white"
          data-testid="f2-start-date"
        />
      </label>
      {!start && show && <span className="font-body text-xs text-stone-500" data-testid="f2-equinox-note">Using the Spring Equinox dates (March 24, 2026)</span>}
      <span className="ml-auto font-body text-sm text-[#2b3550]" data-testid="f2-progress-count">{doneCount} of 52 complete</span>
    </div>
  );
}
